export default __webpack_public_path__ + "static/media/hiw-slide-2.e7aa6de9.png";